const REACT_APP_BSC_BASE_URL = process.env.REACT_APP_BSC_BASE_URL
const REACT_APP_KLAY_BASE_URL = process.env.REACT_APP_KLAY_BASE_URL
const REACT_APP_HPP_BASE_URL = process.env.REACT_APP_HPP_BASE_URL
const REACT_APP_BCS_NFT_AI_BASE_URL = process.env.REACT_APP_BSC_NFT_AI_URL
const REACT_APP_HPP_NFT_AI_BASE_URL = process.env.REACT_APP_HPP_NFT_AI_URL

import KlayIcon from '@/assets/images/klaytn-icon.png'
import BinanceIcon from '@/assets/images/binance-icon.png'

export const NETWORKS_LIST = [
    {
        name: 'Binance Smart Chain',
        baseUrl: REACT_APP_BSC_BASE_URL,
        icon: BinanceIcon,
    },
    {
        name: 'Klaytn Cypress',
        baseUrl: REACT_APP_KLAY_BASE_URL,
        icon: KlayIcon,
    },
    {
        name: 'HPP',
        baseUrl: REACT_APP_HPP_BASE_URL,
        icon: 'https://docs.hpp.io/~gitbook/image?url=https%3A%2F%2F1765098368-files.gitbook.io%2F%7E%2Ffiles%2Fv0%2Fb%2Fgitbook-x-prod.appspot.com%2Fo%2Forganizations%252FSO8h5IOmucs1fpTBSN8y%252Fsites%252Fsite_6iFMO%252Ficon%252FeGpNS22ivMfmSUKaLXpu%252FChain%2520icon_black.svg%3Falt%3Dmedia%26token%3D3e5076c8-48fc-4375-8bf4-b5f8ae891182&width=32&dpr=4&quality=100&sign=552d717c&sv=2',
    },
]

export const NETWORKS_LIST_NFT_AI = [
    {
        name: 'Binance Smart Chain',
        baseUrl: REACT_APP_BCS_NFT_AI_BASE_URL,
        icon: BinanceIcon,
    },
    {
        name: 'HPP',
        baseUrl: REACT_APP_HPP_NFT_AI_BASE_URL,
        icon: 'https://docs.hpp.io/~gitbook/image?url=https%3A%2F%2F1765098368-files.gitbook.io%2F%7E%2Ffiles%2Fv0%2Fb%2Fgitbook-x-prod.appspot.com%2Fo%2Forganizations%252FSO8h5IOmucs1fpTBSN8y%252Fsites%252Fsite_6iFMO%252Ficon%252FeGpNS22ivMfmSUKaLXpu%252FChain%2520icon_black.svg%3Falt%3Dmedia%26token%3D3e5076c8-48fc-4375-8bf4-b5f8ae891182&width=32&dpr=4&quality=100&sign=552d717c&sv=2',
    },
]
